import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import DefaultGoogleAds from "./DefaultGoogleAds";
import GoogleAdsTable from "./GoogleAdsTable";
import GoogleAddFormModal from "../../../../../components/Modals/GoogleAddFormModal";
import {
  getProjectFormIds,
  getAllApikeys,
  deleteProjectFormId,
  getLandingPageIntegration,
  markLeadActive,
  markLeadInactive,
  getAllProjects,
  getAuthRolePermissions,
} from "../../../../../services/private/company.service";
import SearchIcon from '../../../../../assets/icons/search.svg';
import Consumer from '../../../../../helpers/context';
import { ReactComponent as Pageback } from '../../../../../assets/icons/Pageback.svg';


const GoogleAds = () => {
  const [showFormIntegration, setShowFormIntegration] = useState(false);
  const [pageIntegrationList, setpageIntegrationList] = useState([]);
  const [viewCodeSnipet, setViewCodeSnipet] = useState(false)
  const [formApiKey, setFormApiKey] = useState("");
  const [apiKey, setApiKey] = useState("");
  // const [editLead, setEditLead] = useState(false)
  const [leadDetail, setLeadDetail] = useState()
  const [projects, setProjects] = useState([]);
  const [integrationPermission, setIntegrationPermission] = useState();
  const [searchText, setSearchText] = useState('');
  const [newIntergrations, setNewIntegration] = useState(false);

  let { allowedPermissions, isRolesModule } = useContext(Consumer);

  useEffect(() => {
    if (!isRolesModule) {
      if (integrationPermission?.includes('write')) {
        console.log('show integrations')
        setNewIntegration(true);
      }
    } else {
      if (allowedPermissions.includes('create_landingpage_integration')) {
        setNewIntegration(true);
      }
    }
  }, [isRolesModule, integrationPermission, allowedPermissions]);

  const getAllPgeIntegration = async () => {
    await getLandingPageIntegration(searchText).then((res) => {
      if (res.status === 200) {
        setpageIntegrationList(res.data.data);
      }
    });
  };

  const getApikey = async () => {
    await getAllApikeys().then((res) => {
      if (res.status === 200) {
        setApiKey(res.data.data?.apikey);
      }
    });
  };

  const inactiveProjectFormId = async (uuid) => {
    await deleteProjectFormId(uuid).then((res) => {
      if (res.status === 200) {
        toast.success(res.data.message);
      }
    });
  };

  const getAllProjectsByCompanyId = async () => {
    await getAllProjects().then((res) => {
      if (res.status === 200) {
        const projects = res.data.data.map((project) => ({ label: project.name, value: project.id }));
        setProjects(projects);
      }
    })
  }

  const getUsersAuthRolePermissions = () => {
    getAuthRolePermissions().then((res) => {
      res.data.data.map((role) => {
        if (role.module === "integration") {
          setIntegrationPermission(role.permissions)
        }
      })
    })
  }

  useEffect(() => {
    getAllPgeIntegration();
    getAllProjectsByCompanyId();
    getApikey();
    getUsersAuthRolePermissions();
  }, []);

  const viewForm = useCallback((apiKey) => {
    setFormApiKey(apiKey);
    setViewCodeSnipet(true)
    setShowFormIntegration(true)
  }, [])

  const setEditLeadDetail = useCallback((details) => {
    setLeadDetail(details)
    setViewCodeSnipet(false)
    setShowFormIntegration(true)
  }, [])

  const makeLeadInactive = (uuid) => {
    markLeadInactive(uuid).then((res) => {
      if (res.status === 200) {
        toast.success(res.data.message);
        getAllPgeIntegration();
      }
    });
  }

  const makeLeadActive = (uuid) => {
    markLeadActive(uuid).then((res) => {
      if (res.status === 200) {
        toast.success(res.data.message);
        getAllPgeIntegration();
      }
    });
  }

  useEffect(() => {
    getAllPgeIntegration();
  }, [searchText])

  const handelClearSearch = useCallback(() => {
    setSearchText('')
  }, []);

  const closeModal = useCallback(() => {
    setLeadDetail({});
    setShowFormIntegration(false);
    setViewCodeSnipet(false)
  }, [])

  return (
    <>
      {showFormIntegration ? (
        <GoogleAddFormModal
          showFormIntegration={showFormIntegration}
          closeModal={closeModal}
          getAllPgeIntegration={getAllPgeIntegration}
          formApiKey={formApiKey}
          viewCodeSnipet={viewCodeSnipet}
          leadDetail={leadDetail}
          projects={projects}
        />
      ) : null}
      <div className="w-100 flex flex-col h-full ">
        <div className="settings-title landingpage-head">
          <div className="row d-flex flex-fill">
            <div className="col-xl-7 col-lg-6 co d-flex flex-fill flex-column">
              <h1 className="fz24 mb-16 black fw-po-medium flex items-center !gap-x-2">
                <Link

                  to='/settings/integrations/all-integrations'
                  className="w-8 h-8 hover:bg-black200 rounded inline-flex items-center justify-center titlebackbtn"
                >
                  <Pageback className="group-hover:stroke-black" />
                </Link>
                Landing Pages
              </h1>
              <p className="fz16 black-dark-700 mb-0 d-xl-block d-none !ml-10">Add New Integration & get leads directly from landing pages</p>
              <p className="fz16 black-dark-700 mb-0 d-xl-none ">Add New & get leads directly from landing pages</p>
            </div>
            <div className="col-xl-5 col-lg-6 justify-content-md-end d-flex d-flex flex-fill align-items-end pl-lg-0">
              <div className={`form-group position-relative search-input ${searchText ? 'input-active' : ''} `}>
                <div className="serch-icon">
                  <img src={SearchIcon} className="" /></div>
                <input type="text" placeholder="Search" onChange={(e) => setSearchText(e.target.value)} className="searchinput" value={searchText} />
                {searchText &&
                  <div className="close-icon" onClick={handelClearSearch}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M5.94131 5.00019L9.45935 8.52142C9.71958 8.78188 9.71939 9.20399 9.45892 9.46423C9.19845 9.72446 8.77634 9.72427 8.51611 9.4638L4.9978 5.9423L1.47122 9.46365C1.21067 9.7238 0.788564 9.72349 0.528408 9.46295C0.268252 9.2024 0.268566 8.78029 0.529109 8.52014L4.05542 4.99907L0.53071 1.47117C0.270478 1.2107 0.270669 0.788594 0.531136 0.528362C0.791603 0.26813 1.21371 0.268321 1.47395 0.528788L4.99893 4.05696L8.51612 0.544989C8.77666 0.284833 9.19877 0.285147 9.45893 0.54569C9.71909 0.806233 9.71877 1.22834 9.45823 1.4885L5.94131 5.00019Z" fill="#696974" />
                    </svg>
                  </div>}
              </div>
              {
                newIntergrations &&
                <button
                  onClick={() => {
                    setLeadDetail({})
                    setShowFormIntegration(!showFormIntegration);
                  }}
                  className="pr-btn ml-12 px-16"
                >
                  <svg className="mr4 d-xl-inline d-none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="path-1-inside-1_1117_451" fill="white">
                      <path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z"></path></mask><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white"></path><path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_1117_451)">
                    </path>
                  </svg>
                  <span className="d-xl-inline d-none ml-0 ">New Integration</span>
                  <span className="d-xl-none ml-0 px-16">Add New</span>

                </button>
              }

            </div>
          </div>
        </div>

        {pageIntegrationList.length ? (
          <GoogleAdsTable
            pageIntegrationList={pageIntegrationList}
            apiKey={apiKey}
            inactiveProjectFormId={(uuid) => inactiveProjectFormId(uuid)}
            viewForm={viewForm}
            makeLeadInactive={makeLeadInactive}
            makeLeadActive={makeLeadActive}
            setEditLeadDetail={setEditLeadDetail}
            integrationPermission={integrationPermission}
          />
        ) : (
          <DefaultGoogleAds
            showFormIntegration={showFormIntegration}
            setShowFormIntegration={setShowFormIntegration}
            integrationPermission={integrationPermission}
            newIntergrations={newIntergrations}
          />
        )}
      </div>
    </>
  );
};

export default GoogleAds;
